import { FormControl, FormGroup } from '@mui/material';
import React from 'react';

import { RadioGroupProps } from './RadioGroup.interface';
import { Label, RadioField, RadioGroupField } from './RadioGroup.styled';

export const RadioGroup = (props: RadioGroupProps) => {
  const selectedVal = React.useRef('');
  if (props.resetVal) {
    selectedVal.current = '';
  }
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    selectedVal.current = event.target.value;
    props.onChange(props.summaryLabel, newValue);
    props.setResetVal(false);
  };

  return (
    <FormGroup>
      <FormControl>
        <RadioGroupField
          onChange={handleChange}
          value={props.resetVal ? '' : selectedVal.current}
          name="radio-buttons-group">
          {props.options.map((option, i) => {
            return (
              <Label
                key={i}
                control={
                  <RadioField
                    name={option.label}
                    color="primary"
                    value={option.value}
                  />
                }
                label={option.label}
              />
            );
          })}
        </RadioGroupField>
      </FormControl>
    </FormGroup>
  );
};
